export const ASCII_BANNER = `

    ::::::::::::::::::::::::::::
    ::+++=::::::::++++++++++++::
    ::@@@@@@*-::::@@@@@@@@@@@@::    ██╗      █████╗ ██████╗ ███████╗      
    ::@@@@@@@@#:::@@@@@@@@@@@*::    ██║     ██╔══██╗██╔══██╗██╔════╝   
    ::@@@@@@@@@@=:@@@@@@@@@@%:::    ██║     ███████║██████╔╝███████╗    
    ::@@@@@@@@@@@-@@@@@@@@@#::::    ██║     ██╔══██║██╔══██╗╚════██║  
    ::@@@@@@@@@@@%@@@@@@@@+:::::    ███████╗██║  ██║██║  ██║███████║    
    ::@@@@@@@@@@@@@@@@%*-:::::::    ╚══════╝╚═╝  ╚═╝╚═╝  ╚═╝╚══════╝   
    ::@@@@@@@@@@@@@@@@*+::::::::
    ::%@@@@@@@@@@@@@@@@@@#-:::::    ██╗  ██╗███████╗███╗   ███╗██████╗ ███████╗██████╗ 
    ::=@@@@@@@@@@@@@@@@@@@@*::::    ██║ ██╔╝██╔════╝████╗ ████║██╔══██╗██╔════╝██╔══██╗
    :::+@@@@@@@@@@@@@@@@@@@@#:::    █████╔╝ █████╗  ██╔████╔██║██████╔╝█████╗  ██████╔╝
    ::::=@@@@@@@@@@@@@@@@@@@@+::    ██╔═██╗ ██╔══╝  ██║╚██╔╝██║██╔═══╝ ██╔══╝  ██╔══██╗
    ::::::=#@@@@@@@@@@@@@@@@@@::    ██║  ██╗███████╗██║ ╚═╝ ██║██║     ███████╗██║  ██║
    ::::::::::=+++************::    ╚═╝  ╚═╝╚══════╝╚═╝     ╚═╝╚═╝     ╚══════╝╚═╝  ╚═╝
    ::::::::::::::::::::::::::::
        
  ┌─About───────────────────────────────┐ ┌─Socials───┬─────────────────────────────────┐
  │                                     │ │           │                                 │
  │ Software Engineer @ Shopware        │ │ Github    │ https://larskemper.dev/github   │
  │ keen on web development and design. │ │ Linkedin  │ https://larskemper.dev/linkedin │
  │                                     │ │           │                                 │
  └─────────────────────────────────────┘ └───────────┴─────────────────────────────────┘
  
  
`;
